import React, { Suspense } from 'react';
import '@/styles/App.css';
import GetRoomScreen from '@screens/GetRoomScreen';
import NotifyProvider from '@components/Providers/NotifyProvider';
import LocalizedTitle from '@components/Providers/LocalizedTitle';
import WebViewProvider from '@components/Providers/WebViewProvider';
import useSentryInit from '@hooks/useSentryInit';

function App() {
  useSentryInit();
  return (
    <Suspense fallback="loading">
      <LocalizedTitle>
        <NotifyProvider>
          <WebViewProvider>
            <GetRoomScreen />
          </WebViewProvider>
        </NotifyProvider>
      </LocalizedTitle>
    </Suspense>
  );
}
export default App;
